import {
  Box,
  Button,
  Dialog,
  Flex,
  Heading,
  IconButton,
  Text,
} from "@radix-ui/themes";
import { InstructionCard } from "./instructions-card";
import { BrandLogo } from "../../components/brand-logo";
import { LangSelector } from "./lang-selector";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Cross2Icon } from "@radix-ui/react-icons";
import { usePostHog } from "@posthog/react";

export function UnmannedEnterInstructions() {
  const { t } = useTranslation();
  const posthog = usePostHog();

  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <Flex direction="column" className="h-full">
      <Flex mb="4" justify="between" className="text-[#232323]">
        <BrandLogo />
        <LangSelector />
      </Flex>
      <Flex direction="column" flexGrow="1" gap="3">
        <Flex className="h-16" justify="center" align="center">
          <Heading className="!text-[2.625rem] !font-semibold">
            {t("startAutonomousCheckout")}
          </Heading>
        </Flex>

        <Flex className="gap-3 flex-1">
          <InstructionCard
            onClick={() => {
              setMoreOpen(true);
              posthog.capture("unmanned_enter_instructions_opened");
            }}
            image="/unmanned/inst-01.webp"
            title={`1. ${t("enterIns1")}`}
            moreButton={
              <Button variant="outline" radius="full" color="gray">
                {t("clickForInformation")}
              </Button>
            }
          />
          <InstructionCard
            image="/unmanned/inst-02_sm.webp"
            title={`2. ${t("enterIns2")}`}
            moreButton={<div className="h-8" />}
          />

          <InstructionCard
            image="/unmanned/inst-03_bigger.png"
            title={`3. ${t("enterIns3")}`}
            moreButton={<div className="h-8" />}
            imgClassName="scale-[1.125]"
          />
        </Flex>
      </Flex>

      <Dialog.Root open={moreOpen} onOpenChange={setMoreOpen}>
        <Dialog.Content
          maxWidth="90vw"
          className="h-90vh !rounded-[32px] !p-4 mobile-fa"
        >
          <Dialog.Close>
            <IconButton
              size="3"
              className="!absolute !top-4 !right-4"
              radius="full"
              color="gray"
              highContrast
            >
              <Cross2Icon width={28} height={28} />
            </IconButton>
          </Dialog.Close>
          <Flex className="h-16" justify="center" align="center" mb="5">
            <Heading className="!text-[1.875rem] !font-semibold">
              {t("moreTitle")}
            </Heading>
          </Flex>

          <Flex className="gap-3 flex-1">
            <InstructionCard
              wrapperClassName="pt-4"
              image="/unmanned/more-01.png"
              title={
                <Box px="4" mt="5" mb="3" className="min-h-[180px]">
                  <Text as="p" size="5" weight="medium">
                    {t("moreIns1")}
                  </Text>
                  <Text as="p" size="3" color="gray">
                    {t("moreInsDetails1")}
                  </Text>
                </Box>
              }
              imgClassName="min-h-[395px] h-[395px] scale-75"
            />
            <InstructionCard
              wrapperClassName="pt-4"
              image={
                <video
                  src="/unmanned/more-02.mp4"
                  loop
                  className="object-contain w-full h-[395px] scale-[0.85] pointer-events-none select-none"
                  autoPlay
                  playsInline
                />
              }
              title={
                <Box px="4" mt="5" mb="3" className="min-h-[180px]">
                  <Text as="p" size="5" weight="medium">
                    {t("moreIns2")}
                  </Text>
                  <Text as="p" size="3" color="gray">
                    {t("moreInsDetails2")}
                  </Text>
                </Box>
              }
              imgClassName="max-h-[395px] scale-[1.3] -translate-x-6"
            />
            <InstructionCard
              wrapperClassName="pt-4"
              image="/unmanned/more-03.png"
              title={
                <Box px="4" mt="5" mb="3" className="min-h-[180px]">
                  <Text as="p" size="5" weight="medium">
                    {t("moreIns3")}
                  </Text>
                  <Text as="p" size="3" color="gray" weight="bold">
                    {t("moreInsDetails3Highlight")}
                  </Text>
                  <Text as="p" size="3" color="gray">
                    {t("moreInsDetails3")}
                  </Text>
                </Box>
              }
              imgClassName="max-h-[395px]"
            />
          </Flex>
        </Dialog.Content>
      </Dialog.Root>
    </Flex>
  );
}
